import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
@IonicPage()
@Component({
  selector: 'page-klmr-timesheet-pending',
  templateUrl: 'klmr-timesheet-pending.html',
})
export class KlmrTimesheetPendingPage {
  timeSheetList: any = [];
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }
  ionViewDidLoad() {
    this.gettimeSheetList();
  }

  async gettimeSheetList() {
    this.timeSheetList = [];
    this.utiltiy.startLoading();
      let userId = await this.utiltiy.getStorage("userId");
      let formData: FormData = new FormData();
      // formData.append("user_id", userId);
      // formData.append("status", "1");
      formData.append("method_name", "pending_list");
      this.api.post(`/prestart/timesheet/approver`, true, formData)
        .then((result: any) => {
          console.log("result", result)
          this.utiltiy.stopLoading();
          this.timeSheetList = result.result;
  
        }, err => {
          console.log("err", err)
          this.utiltiy.stopLoading();
          this.utiltiy.toaster(err.error.message);
        })
  }

  formatAMPM(date) {
    date = date.split(":");
    var hours = date[0];
    var minutes = date[1];
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = date[0] + ':' + date[1];
    return strTime;
  }

  deleteTimeSheet(id) {
    this.api.delete(`/prestart/timesheet/delete/${id}`, false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.gettimeSheetList();
        }

      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/klmr-timesheet-pending/klmr-timesheet-pending.ts